'use client';
import { createContext, useContext } from 'react';
export const HeaderStateContext = createContext(undefined);
export const useHeaderState = () => {
    const context = useContext(HeaderStateContext);
    if (!context) {
        throw new Error('useHeaderState must be used with in the Header');
    }
    return context;
};
